// src/module_mechanics/TransactionsManager.jsx
import React, { useState, useEffect, useRef, useCallback, Fragment, forwardRef } from 'react';
import { useAuth } from '../pages/AuthContext';
// import './Styles/TransactionsUI.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExchangeAlt, faUsers, faTruck, faUserTie, faMoneyBillWave,
    faPlus, faSearch, faFilter, faFilePdf, faDownload, faEye,
    faTimes, faSave, faTrash, faEdit, faChevronLeft, faChevronRight,
    faDollarSign, faCalendarAlt, faClock, faBuilding, faWallet,
    faCreditCard, faStickyNote, faCheckCircle, faExclamationTriangle,
    faChartLine, faChartPie, faReceipt, faUndo, faUserPlus,
    faTruckLoading, faCoins, faFileInvoice, faPrint, faSpinner,
    faWrench, faTools, faClipboardList, faArrowDown, faArrowUp,
    faSync, faRefresh, faBoxes, faTag, faStore, faMinus, faArrowsAlt,
    faExpand, faChevronDown, faChevronUp
} from '@fortawesome/free-solid-svg-icons';

// ─────────────────────────────────────────────────────────────
// 🌍 TRANSLATION SYSTEM
// ─────────────────────────────────────────────────────────────
const createTransactionsTranslator = () => {
    let cache = new Map();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Unified Transactions': 'یونیفائیڈ ٹرانزیکشنز',
                'All Transactions': 'تمام ٹرانزیکشنز',
                'Service Transactions': 'سروس ٹرانزیکشنز',
                'Customers': 'کسٹمرز',
                'Suppliers': 'سپلائرز',
                'Employees': 'ملازمین',
                'Expenses': 'اخراجات',
                'Add Transaction': 'ٹرانزیکشن شامل کریں',
                'Select Type': 'قسم منتخب کریں',
                'Select Customer': 'کسٹمر منتخب کریں',
                'Select Supplier': 'سپلائر منتخب کریں',
                'Select Employee': 'ملازم منتخب کریں',
                'Amount': 'رقم',
                'Date': 'تاریخ',
                'Description': 'تفصیل',
                'Payment Method': 'ادائیگی کا طریقہ',
                'Cash': 'نقد',
                'Bank Transfer': 'بینک ٹرانسفر',
                'Cheque': 'چیک',
                'Credit Card': 'کریڈٹ کارڈ',
                'Mobile Payment': 'موبائل پیمنٹ',
                'Invoice Number': 'انوائس نمبر',
                'Save': 'محفوظ کریں',
                'Cancel': 'منسوخ کریں',
                'Close': 'بند کریں',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Loading...': 'لوڈ ہو رہا ہے...',
                'No transactions found': 'کوئی ٹرانزیکشن نہیں ملی',
                'No services found': 'کوئی سروس نہیں ملی',
                'Refresh': 'ریفریش کریں',
                'Filter by Date': 'تاریخ کے مطابق فلٹر کریں',
                'Export to PDF': 'پی ڈی ایف ایکسپورٹ کریں',
                'Search': 'تلاش کریں',
                'Total Sales': 'کل فروخت',
                'Total Payments Received': 'کل وصول شدہ ادائیگیاں',
                'Total Expenses': 'کل اخراجات',
                'Net Balance': 'خالص بیلنس',
                'Transaction Details': 'ٹرانزیکشن کی تفصیلات',
                'Profile Summary': 'پروفائل کا خلاصہ',
                'Total Purchases': 'کل خریداری',
                'Total Paid': 'کل ادا کردہ',
                'Current Due': 'موجودہ بقایا',
                'Reset Filters': 'فلٹرز ری سیٹ کریں',
                'Show All': 'سب دکھائیں',
                'Completed': 'مکمل',
                'Pending': 'زیر التواء',
                'Cancelled': 'منسوخ',
                'Refunded': 'واپس',
                'Actions': 'اعمال',
                'View': 'دیکھیں',
                'View Details': 'تفصیلات دیکھیں',
                'Hide Details': 'تفصیلات چھپائیں',
                'services available': 'سروسز دستیاب ہیں',
                'S.No': 'نمبر',
                'Transaction ID': 'ٹرانزیکشن آئی ڈی',
                'Type': 'قسم',
                'Reference': 'حوالہ',
                'Status': 'حالت',
                'Service Number': 'سروس نمبر',
                'Customer Name': 'کسٹمر نام',
                'Vehicle Details': 'گاڑی کی تفصیلات',
                'Grand Total': 'کل رقم',
                'Paid Amount': 'ادا شدہ رقم',
                'Balance Due': 'بقایا رقم',
                'Service Info': 'سروس کی معلومات',
                'Related Transactions': 'متعلقہ ٹرانزیکشنز',
                'showing': 'دکھا رہا ہے',
                'of': 'میں سے',
                'transactions': 'ٹرانزیکشنز',
                'previous': 'پچھلا',
                'next': 'اگلا',
                'apply': 'لاگو کریں',
                'startDate': 'شروع تاریخ',
                'endDate': 'اختتام تاریخ'
            },
            'ar': {
                'Unified Transactions': 'المعاملات الموحدة',
                'All Transactions': 'جميع المعاملات',
                'Service Transactions': 'معاملات الخدمة',
                'Customers': 'العملاء',
                'Suppliers': 'الموردين',
                'Employees': 'الموظفين',
                'Expenses': 'المصروفات',
                'Add Transaction': 'إضافة معاملة',
                'Select Type': 'اختر النوع',
                'Select Customer': 'اختر عميل',
                'Select Supplier': 'اختر مورد',
                'Select Employee': 'اختر موظف',
                'Amount': 'المبلغ',
                'Date': 'التاريخ',
                'Description': 'الوصف',
                'Payment Method': 'طريقة الدفع',
                'Cash': 'نقدي',
                'Bank Transfer': 'تحويل بنكي',
                'Cheque': 'شيك',
                'Credit Card': 'بطاقة ائتمان',
                'Mobile Payment': 'دفع عبر الجوال',
                'Invoice Number': 'رقم الفاتورة',
                'Save': 'حفظ',
                'Cancel': 'إلغاء',
                'Close': 'إغلاق',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Loading...': 'جاري التحميل...',
                'No transactions found': 'لا توجد معاملات',
                'No services found': 'لا توجد خدمات',
                'Refresh': 'تحديث',
                'Filter by Date': 'تصفية حسب التاريخ',
                'Export to PDF': 'تصدير إلى PDF',
                'Search': 'بحث',
                'Total Sales': 'إجمالي المبيعات',
                'Total Payments Received': 'إجمالي المدفوعات المستلمة',
                'Total Expenses': 'إجمالي المصروفات',
                'Net Balance': 'صافي الرصيد',
                'Transaction Details': 'تفاصيل المعاملة',
                'Profile Summary': 'ملخص الملف الشخصي',
                'Total Purchases': 'إجمالي المشتريات',
                'Total Paid': 'إجمالي المدفوع',
                'Current Due': 'المستحق الحالي',
                'Reset Filters': 'إعادة تعيين المرشحات',
                'Show All': 'عرض الكل',
                'Completed': 'مكتمل',
                'Pending': 'قيد الانتظار',
                'Cancelled': 'ملغي',
                'Refunded': 'مسترجع',
                'Actions': 'الإجراءات',
                'View': 'عرض',
                'View Details': 'عرض التفاصيل',
                'Hide Details': 'إخفاء التفاصيل',
                'services available': 'خدمات متاحة',
                'S.No': 'رقم',
                'Transaction ID': 'رقم المعاملة',
                'Type': 'النوع',
                'Reference': 'مرجع',
                'Status': 'الحالة',
                'Service Number': 'رقم الخدمة',
                'Customer Name': 'اسم العميل',
                'Vehicle Details': 'تفاصيل المركبة',
                'Grand Total': 'المجموع الكلي',
                'Paid Amount': 'المبلغ المدفوع',
                'Balance Due': 'الرصيد المستحق',
                'Service Info': 'معلومات الخدمة',
                'Related Transactions': 'المعاملات ذات الصلة',
                'showing': 'عرض',
                'of': 'من',
                'transactions': 'المعاملات',
                'previous': 'السابق',
                'next': 'التالي',
                'apply': 'تطبيق',
                'startDate': 'تاريخ البدء',
                'endDate': 'تاريخ الانتهاء'
            },
            'es': {
                'Unified Transactions': 'Transacciones Unificadas',
                'All Transactions': 'Todas las Transacciones',
                'Service Transactions': 'Transacciones de Servicio',
                'Customers': 'Clientes',
                'Suppliers': 'Proveedores',
                'Employees': 'Empleados',
                'Expenses': 'Gastos',
                'Add Transaction': 'Agregar Transacción',
                'Select Type': 'Seleccionar Tipo',
                'Select Customer': 'Seleccionar Cliente',
                'Select Supplier': 'Seleccionar Proveedor',
                'Select Employee': 'Seleccionar Empleado',
                'Amount': 'Monto',
                'Date': 'Fecha',
                'Description': 'Descripción',
                'Payment Method': 'Método de Pago',
                'Cash': 'Efectivo',
                'Bank Transfer': 'Transferencia Bancaria',
                'Cheque': 'Cheque',
                'Credit Card': 'Tarjeta de Crédito',
                'Mobile Payment': 'Pago Móvil',
                'Invoice Number': 'Número de Factura',
                'Save': 'Guardar',
                'Cancel': 'Cancelar',
                'Close': 'Cerrar',
                'Success': 'Éxito',
                'Error': 'Error',
                'Warning': 'Advertencia',
                'Loading...': 'Cargando...',
                'No transactions found': 'No se encontraron transacciones',
                'No services found': 'No se encontraron servicios',
                'Refresh': 'Actualizar',
                'Filter by Date': 'Filtrar por Fecha',
                'Export to PDF': 'Exportar a PDF',
                'Search': 'Buscar',
                'Total Sales': 'Ventas Totales',
                'Total Payments Received': 'Pagos Recibidos Totales',
                'Total Expenses': 'Gastos Totales',
                'Net Balance': 'Balance Neto',
                'Transaction Details': 'Detalles de Transacción',
                'Profile Summary': 'Resumen de Perfil',
                'Total Purchases': 'Compras Totales',
                'Total Paid': 'Total Pagado',
                'Current Due': 'Deuda Actual',
                'Reset Filters': 'Restablecer Filtros',
                'Show All': 'Mostrar Todo',
                'Completed': 'Completado',
                'Pending': 'Pendiente',
                'Cancelled': 'Cancelado',
                'Refunded': 'Reembolsado',
                'Actions': 'Acciones',
                'View': 'Ver',
                'View Details': 'Ver Detalles',
                'Hide Details': 'Ocultar Detalles',
                'services available': 'servicios disponibles',
                'S.No': 'N°',
                'Transaction ID': 'ID Transacción',
                'Type': 'Tipo',
                'Reference': 'Referencia',
                'Status': 'Estado',
                'Service Number': 'Número de Servicio',
                'Customer Name': 'Nombre del Cliente',
                'Vehicle Details': 'Detalles del Vehículo',
                'Grand Total': 'Total General',
                'Paid Amount': 'Monto Pagado',
                'Balance Due': 'Saldo Pendiente',
                'Service Info': 'Información del Servicio',
                'Related Transactions': 'Transacciones Relacionadas',
                'showing': 'Mostrando',
                'of': 'de',
                'transactions': 'transacciones',
                'previous': 'Anterior',
                'next': 'Siguiente',
                'apply': 'Aplicar',
                'startDate': 'Fecha de inicio',
                'endDate': 'Fecha de fin'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) {
            console.log("Translation failed");
        }
        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        unifiedTransactions: 'Unified Transactions',
        allTransactions: 'All Transactions',
        serviceTransactions: 'Service Transactions',
        customers: 'Customers',
        suppliers: 'Suppliers',
        employees: 'Employees',
        expenses: 'Expenses',
        addTransaction: 'Add Transaction',
        selectType: 'Select Type',
        selectCustomer: 'Select Customer',
        selectSupplier: 'Select Supplier',
        selectEmployee: 'Select Employee',
        amount: 'Amount',
        date: 'Date',
        description: 'Description',
        paymentMethod: 'Payment Method',
        cash: 'Cash',
        bankTransfer: 'Bank Transfer',
        cheque: 'Cheque',
        creditCard: 'Credit Card',
        mobilePayment: 'Mobile Payment',
        invoiceNumber: 'Invoice Number',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        loading: 'Loading...',
        noTransactions: 'No transactions found',
        noServices: 'No services found',
        refresh: 'Refresh',
        filterByDate: 'Filter by Date',
        exportPDF: 'Export to PDF',
        search: 'Search',
        totalSales: 'Total Sales',
        totalPaymentsReceived: 'Payments Received',
        totalExpenses: 'Total Expenses',
        netBalance: 'Net Balance',
        transactionDetails: 'Transaction Details',
        profileSummary: 'Profile Summary',
        totalPurchases: 'Total Purchases',
        totalPaid: 'Total Paid',
        currentDue: 'Current Due',
        resetFilters: 'Reset Filters',
        showAll: 'Show All',
        completed: 'Completed',
        pending: 'Pending',
        cancelled: 'Cancelled',
        refunded: 'Refunded',
        actions: 'Actions',
        view: 'View',
        viewDetails: 'View Details',
        hideDetails: 'Hide Details',
        customerDue: 'Customer Due',
        customerPayment: 'Customer Payment',
        supplierPayment: 'Supplier Payment',
        salaryPayment: 'Salary Payment',
        shopExpense: 'Shop Expense',
        serviceNumber: 'Service Number',
        customerName: 'Customer Name',
        vehicleDetails: 'Vehicle Details',
        grandTotal: 'Grand Total',
        paidAmount: 'Paid Amount',
        balanceDue: 'Balance Due',
        relatedTransactions: 'Related Transactions',
        serviceAmount: 'Service Amount',
        taskBasedPayments: 'Task Based Payments',
        serviceInfo: 'Service Information',
        type: 'Type',
        referenceName: 'Reference',
        status: 'Status',
        startDate: 'Start Date',
        endDate: 'End Date',
        servicesAvailable: 'services available',
        serialNo: 'S.No',
        transactionId: 'Transaction ID',
        showing: 'Showing',
        of: 'of',
        transactions: 'transactions',
        previous: 'Previous',
        next: 'Next',
        apply: 'Apply'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') return defaultTexts;
        const translations = {};
        const promises = [];
        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });
        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }
        return translations;
    };

    loadFromCache();
    return { getTranslations, translateText };
};

const transactionsTranslator = createTransactionsTranslator();

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations.success || 'Success';
            case 'error': return translations.error || 'Error';
            case 'warning': return translations.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`oztransui_toast-notification ${toast.type}`}>
            <div className="oztransui_toast-content">
                <div className="oztransui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="oztransui_toast-text">
                    <div className="oztransui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="oztransui_toast-message">{toast.message}</div>
                </div>
                <button className="oztransui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            <div className="oztransui_toast-timer">
                <div 
                    className="oztransui_toast-progress-bar" 
                    style={{ width: `${toast.progress || 100}%` }}
                ></div>
            </div>
        </div>
    );
};

// Custom Dropdown Component with forwardRef and Tab closing
const CustomDropdown = forwardRef(({ label, icon, value, onChange, options, placeholder, translations, disabled = false }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [menuStyle, setMenuStyle] = useState({});
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);
    const displayValue = selectedOption?.label || '';

    useEffect(() => {
        setSearchTerm(displayValue);
    }, [displayValue]);

    const filteredOptions = searchTerm.trim() === ''
        ? options
        : options.filter(opt =>
            opt.label.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const updateMenuPosition = () => {
        if (wrapperRef.current) {
            const rect = wrapperRef.current.getBoundingClientRect();
            setMenuStyle({
                position: 'fixed',
                top: rect.bottom,
                left: rect.left,
                width: rect.width,
                zIndex: 999999,
            });
        }
    };

    const handleSelect = (option) => {
        onChange(option.value);
        setSearchTerm(option.label);
        setIsOpen(false);
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    useEffect(() => {
        if (isOpen) {
            updateMenuPosition();
        }
    }, [isOpen]);

    // Reposition on scroll or resize while open
    useEffect(() => {
        if (!isOpen) return;

        const handleScroll = () => updateMenuPosition();
        const handleResize = () => updateMenuPosition();

        window.addEventListener('scroll', handleScroll, true);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll, true);
            window.removeEventListener('resize', handleResize);
        };
    }, [isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                // Also check if click is inside the menu (which is now fixed positioned outside wrapper)
                const menu = document.querySelector('.oztransui-custom-dropdown-menu-active');
                if (menu && menu.contains(event.target)) return;
                setIsOpen(false);
            }
        };

        const handleTabKey = (e) => {
            if (e.key === 'Tab' && isOpen) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleTabKey);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleTabKey);
        };
    }, [isOpen]);

    return (
        <div className="oztransui-custom-dropdown-wrapper" ref={wrapperRef}>
            <div className="oztransui-custom-input-wrapper">
                <input
                    ref={(node) => {
                        inputRef.current = node;
                        if (ref) {
                            if (typeof ref === 'function') ref(node);
                            else ref.current = node;
                        }
                    }}
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setIsOpen(true);
                        if (!options.find(opt => opt.label.toLowerCase() === e.target.value.toLowerCase())) {
                            onChange('');
                        }
                    }}
                    onFocus={() => {
                        setIsOpen(true);
                        updateMenuPosition();
                    }}
                    placeholder=" "
                    disabled={disabled}
                    autoComplete="off"
                />
                <label>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {label}
                </label>
                <FontAwesomeIcon icon={faChevronDown} className="oztransui-custom-dropdown-arrow" />
            </div>

            {isOpen && (
                <div
                    className="oztransui-custom-dropdown-menu oztransui-custom-dropdown-menu-active"
                    style={menuStyle}
                >
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map(opt => (
                            <div
                                key={opt.value}
                                className={`oztransui-custom-dropdown-option ${value === opt.value ? 'oztransui-selected' : ''}`}
                                onClick={() => handleSelect(opt)}
                            >
                                {opt.label}
                            </div>
                        ))
                    ) : (
                        <div className="oztransui-custom-dropdown-empty">
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
});

const TransactionsManager = () => {
    const { user, currentShop } = useAuth();
    
    // ─────────────────────────────────────────────────────────
    // 🌍 LANGUAGE & THEME STATE
    // ─────────────────────────────────────────────────────────
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [translations, setTranslations] = useState({});
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [currentThemeColor, setCurrentThemeColor] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#10b981';
    });
    
    // ─────────────────────────────────────────────────────────
    // 📦 STATE MANAGEMENT
    // ─────────────────────────────────────────────────────────
    const [activeTab, setActiveTab] = useState('all');
    const [showAddModal, setShowAddModal] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [transactionType, setTransactionType] = useState('customer_due');
    const [transactions, setTransactions] = useState([]);
    const [filteredTransactions, setFilteredTransactions] = useState([]);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [profileType, setProfileType] = useState(null);
    const [profileTransactions, setProfileTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [employees, setEmployees] = useState([]);
    
    // Modal drag and resize state
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [modalSize, setModalSize] = useState({ width: 550, height: 'auto' });
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [currentWidthMode, setCurrentWidthMode] = useState('medium');
    const [isModalInitialized, setIsModalInitialized] = useState(false);
    const dragStart = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);
    const resizeType = useRef(null);
    const resizeStart = useRef({ x: 0, y: 0, width: 0, height: 0, left: 0, top: 0 });
    
    // Auto-focus ref for form
    const firstInputRef = useRef(null);
    
    // Width modes for modal resizing
    const widthModes = {
        narrow: { width: 400, label: 'Narrow', icon: faMinus },
        medium: { width: 550, label: 'Medium', icon: faArrowsAlt },
        wide: { width: 700, label: 'Wide', icon: faPlus },
        full: { width: '90vw', label: 'Full Width', icon: faExpand }
    };
    
    // Service transaction states
    const [services, setServices] = useState([]);
    const [servicesLoading, setServicesLoading] = useState(false);
    const [expandedServiceId, setExpandedServiceId] = useState(null);
    const [serviceDetailsMap, setServiceDetailsMap] = useState({});
    const [serviceTransactionsMap, setServiceTransactionsMap] = useState({});
    const [loadingServiceId, setLoadingServiceId] = useState(null);
    const [serviceSearchTerm, setServiceSearchTerm] = useState('');

    const [summary, setSummary] = useState({
        total_sales: 0,
        total_payments_received: 0,
        total_expenses: 0,
        total_payments_to_suppliers: 0,
        total_salary_payments: 0,
        total_refunds: 0,
        net_balance: 0
    });
    
    const [filters, setFilters] = useState({
        start_date: '',
        end_date: '',
        transaction_type: '',
        status: '',
        search: ''
    });
    
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        limit: 20
    });
    
    const [toast, setToast] = useState({ show: false, type: '', message: '', progress: 100 });
    
    const [formData, setFormData] = useState({
        reference_id: '',
        amount: '',
        transaction_date: new Date().toISOString().split('T')[0],
        description: '',
        payment_method: 'cash',
        invoice_number: '',
        expense_category: '',
        expense_name: '',
        vendor_name: '',
        salary_type: 'salary'
    });

    const abortControllerRef = useRef(null);
    const isLoadingRef = useRef(false);
    const toastTimerRef = useRef(null);

    const t = (key) => translations[key] || key;

    // Dropdown options
    const transactionTypeOptions = [
        { value: 'customer_due', label: t('customerDue') },
        { value: 'customer_payment', label: t('customerPayment') },
        { value: 'supplier_payment', label: t('supplierPayment') },
        { value: 'employee_salary', label: t('salaryPayment') },
        { value: 'expense', label: t('shopExpense') }
    ];

    const paymentMethodOptions = [
        { value: 'cash', label: t('cash') },
        { value: 'bank_transfer', label: t('bankTransfer') },
        { value: 'cheque', label: t('cheque') },
        { value: 'credit_card', label: t('creditCard') },
        { value: 'mobile_payment', label: t('mobilePayment') }
    ];

    const filterTransactionTypeOptions = [
        { value: '', label: t('showAll') },
        { value: 'service', label: t('serviceTransactions') },
        { value: 'due', label: t('customerDue') },
        { value: 'payment_received', label: t('customerPayment') },
        { value: 'payment_to_supplier', label: t('supplierPayment') },
        { value: 'salary_payment', label: t('salaryPayment') },
        { value: 'expense', label: t('shopExpense') }
    ];

    const filterStatusOptions = [
        { value: '', label: t('showAll') },
        { value: 'completed', label: t('completed') },
        { value: 'pending', label: t('pending') },
        { value: 'cancelled', label: t('cancelled') }
    ];

    // ─────────────────────────────────────────────────────────
    // 🔔 TOAST NOTIFICATIONS
    // ─────────────────────────────────────────────────────────
    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message, progress: 100 });
        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;
            setToast(prev => ({ ...prev, progress: Math.max(0, progress) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);
        toastTimerRef.current = timer;
    }, []);

    // ─────────────────────────────────────────────────────────
    // 🎯 AUTO-FOCUS WHEN MODAL OPENS
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        if (showAddModal && firstInputRef.current) {
            setTimeout(() => {
                firstInputRef.current.focus();
            }, 150);
        }
    }, [showAddModal]);

    // ─────────────────────────────────────────────────────────
    // 🎨 MODAL CONTROL FUNCTIONS
    // ─────────────────────────────────────────────────────────
    const centerModal = useCallback(() => {
        if (!modalRef.current) return;
        const rect = modalRef.current.getBoundingClientRect();
        const left = (window.innerWidth - rect.width) / 2;
        const top = (window.innerHeight - rect.height) / 2;
        modalRef.current.style.left = `${Math.max(0, left)}px`;
        modalRef.current.style.top = `${Math.max(0, top)}px`;
        modalRef.current.style.transform = 'none';
        setModalPosition({ x: Math.max(0, left), y: Math.max(0, top) });
    }, []);

    const setWidthMode = useCallback((mode) => {
        if (!modalRef.current) return;
        setCurrentWidthMode(mode);
        const widthValue = widthModes[mode].width;
        modalRef.current.style.width = typeof widthValue === 'number' ? `${widthValue}px` : widthValue;
        modalRef.current.style.height = 'auto';
        setModalSize({ width: modalRef.current.offsetWidth, height: modalRef.current.offsetHeight });
        setTimeout(() => centerModal(), 10);
    }, [widthModes, centerModal]);

    const startDrag = useCallback((e) => {
        if (!modalRef.current) return;
        if (e.target.closest('button, input, select, textarea, a, .oztransui-width-btn, .oztransui-modal-close')) return;
        e.preventDefault();
        setIsDragging(true);
        const rect = modalRef.current.getBoundingClientRect();
        dragStart.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        modalRef.current.style.transition = 'none';
    }, []);

    const startResize = useCallback((e, type) => {
        e.preventDefault();
        e.stopPropagation();
        if (!modalRef.current) return;
        setIsResizing(true);
        resizeType.current = type;
        const rect = modalRef.current.getBoundingClientRect();
        resizeStart.current = {
            x: e.clientX, y: e.clientY,
            width: rect.width, height: rect.height,
            left: rect.left, top: rect.top,
            minWidth: 350, minHeight: 400,
            maxWidth: window.innerWidth - 40, maxHeight: window.innerHeight - 40
        };
        modalRef.current.style.transition = 'none';
    }, []);

    // ─────────────────────────────────────────────────────────
    // 🎨 THEME COLOR AUTO-SYNC
    // ─────────────────────────────────────────────────────────
    const applyThemeToDocument = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
            color = '#10b981';
        }
        
        document.documentElement.style.setProperty('--oztransui-primary', color);
        
        let r, g, b;
        if (color.startsWith('#')) {
            r = parseInt(color.slice(1, 3), 16);
            g = parseInt(color.slice(3, 5), 16);
            b = parseInt(color.slice(5, 7), 16);
        } else {
            r = 16; g = 185; b = 129;
        }
        
        let style = document.getElementById('oztransui-theme-styles');
        if (!style) {
            style = document.createElement('style');
            style.id = 'oztransui-theme-styles';
            document.head.appendChild(style);
        }
        
        style.textContent = `
            .oztransui-summary-card .card-icon.sales {
                background: linear-gradient(135deg, ${color}, rgba(${r}, ${g}, ${b}, 0.8)) !important;
            }
            .oztransui-btn-primary,
            .oztransui-tab.active,
            .oztransui-custom-dropdown-option.oztransui-selected {
                background: ${color} !important;
            }
            .oztransui-btn-primary:hover {
                background: rgba(${r}, ${g}, ${b}, 0.9) !important;
            }
            .oztransui-reference-link {
                color: ${color} !important;
            }
            .oztransui-reference-link:hover {
                color: rgba(${r}, ${g}, ${b}, 0.8) !important;
            }
            .oztransui-header-icon {
                background: linear-gradient(135deg, ${color}, rgba(${r}, ${g}, ${b}, 0.8)) !important;
            }
            .oztransui-header-bg-animation .gradient-orb.orb-1 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.4) 0%, rgba(${r}, ${g}, ${b}, 0.1) 100%);
            }
            .oztransui-header-bg-animation .gradient-orb.orb-2 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.35) 0%, rgba(${r}, ${g}, ${b}, 0.08) 100%);
            }
            .oztransui-header-bg-animation .gradient-orb.orb-3 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.05) 100%);
            }
            .oztransui-header-bg-animation .gradient-orb.orb-4 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.25) 0%, rgba(${r}, ${g}, ${b}, 0.03) 100%);
            }
            .oztransui-header-bg-animation .gradient-orb.orb-5 {
                background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.2) 0%, rgba(${r}, ${g}, ${b}, 0.02) 100%);
            }
            .oztransui-search-box input:focus,
            .oztransui-form-group input:focus,
            .oztransui-form-group select:focus,
            .oztransui-form-group textarea:focus,
            .oztransui-custom-input-wrapper input:focus {
                border-color: ${color} !important;
                box-shadow: 0 0 0 3px rgba(${r}, ${g}, ${b}, 0.1) !important;
            }
            .oztransui-form-group input:focus ~ label,
            .oztransui-form-group select:focus ~ label,
            .oztransui-form-group textarea:focus ~ label,
            .oztransui-custom-input-wrapper input:focus ~ label {
                color: ${color} !important;
            }
        `;
        
        setCurrentThemeColor(color);
    }, []);

    // Auto-sync theme with dashboard changes
    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#10b981';
        applyThemeToDocument(savedTheme);
        
        const forceThemeUpdate = () => {
            const currentTheme = localStorage.getItem('ourzest_theme') || '#10b981';
            if (currentTheme !== currentThemeColor) {
                applyThemeToDocument(currentTheme);
            }
        };
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                applyThemeToDocument(e.newValue || '#10b981');
            }
        };
        
        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyThemeToDocument(event.detail.theme);
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);
        
        const interval = setInterval(forceThemeUpdate, 1000);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [applyThemeToDocument, currentThemeColor]);

    // ─────────────────────────────────────────────────────────
    // 🌙 DARK MODE AUTO-SYNC
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        const syncDarkMode = () => {
            const isDark = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);
            const container = document.querySelector('.oztransui-container');
            if (container) {
                if (isDark) {
                    container.classList.add('oztransui-dark');
                } else {
                    container.classList.remove('oztransui-dark');
                }
            }
            if (isDark) {
                document.body.classList.add('oztransui-dark');
            } else {
                document.body.classList.remove('oztransui-dark');
            }
        };
        
        syncDarkMode();
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') syncDarkMode();
        };
        
        const handleDarkModeToggle = (event) => {
            const isDark = event.detail?.darkMode ?? localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDark);
            const container = document.querySelector('.oztransui-container');
            if (container) {
                isDark ? container.classList.add('oztransui-dark') : container.classList.remove('oztransui-dark');
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);
        
        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 1000);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [darkMode]);

    // ─────────────────────────────────────────────────────────
    // 🌍 LANGUAGE AUTO-SYNC
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await transactionsTranslator.getTranslations(lang);
            setTranslations(trans);
        };
        
        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };
        
        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };
        
        loadTranslations(currentLanguage);
        
        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);
        
        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);
        
        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);
    
    // RTL direction sync
    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
    
    useEffect(() => {
        const container = document.querySelector('.oztransui-container');
        if (container) {
            if (isRTL) {
                container.classList.add('oztransui-rtl');
                container.classList.remove('oztransui-ltr');
            } else {
                container.classList.add('oztransui-ltr');
                container.classList.remove('oztransui-rtl');
            }
        }
        document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
        document.body.dir = isRTL ? 'rtl' : 'ltr';
    }, [isRTL]);

    // ─────────────────────────────────────────────────────────
    // 🖱️ MODAL DRAG/RESIZE EFFECTS
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging && modalRef.current) {
                let newLeft = e.clientX - dragStart.current.x;
                let newTop = e.clientY - dragStart.current.y;
                const rect = modalRef.current.getBoundingClientRect();
                newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - rect.width));
                newTop = Math.max(0, Math.min(newTop, window.innerHeight - rect.height));
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                modalRef.current.style.transform = 'none';
                setModalPosition({ x: newLeft, y: newTop });
            }

            if (isResizing && modalRef.current && resizeType.current) {
                let newWidth = resizeStart.current.width;
                let newHeight = resizeStart.current.height;
                let newLeft = resizeStart.current.left;
                let newTop = resizeStart.current.top;
                const deltaX = e.clientX - resizeStart.current.x;
                const deltaY = e.clientY - resizeStart.current.y;

                switch (resizeType.current) {
                    case 'e': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); break;
                    case 'w': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                    case 's': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'n': newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'ne': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'nw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height - deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); newTop = resizeStart.current.top + (resizeStart.current.height - newHeight); break;
                    case 'se': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width + deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); break;
                    case 'sw': newWidth = Math.min(resizeStart.current.maxWidth, Math.max(resizeStart.current.minWidth, resizeStart.current.width - deltaX)); newHeight = Math.min(resizeStart.current.maxHeight, Math.max(resizeStart.current.minHeight, resizeStart.current.height + deltaY)); newLeft = resizeStart.current.left + (resizeStart.current.width - newWidth); break;
                }
                modalRef.current.style.width = `${newWidth}px`;
                modalRef.current.style.height = `${newHeight}px`;
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalSize({ width: newWidth, height: newHeight });
                setModalPosition({ x: newLeft, y: newTop });
            }
        };

        const handleMouseUp = () => {
            if (isDragging || isResizing) {
                setIsDragging(false);
                setIsResizing(false);
                resizeType.current = null;
                if (modalRef.current) modalRef.current.style.transition = '';
            }
        };

        if (isDragging || isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, isResizing]);

    // Modal initialization effect
    useEffect(() => {
        if (showAddModal && modalRef.current && !isModalInitialized) {
            setTimeout(() => { centerModal(); setWidthMode('medium'); setIsModalInitialized(true); }, 50);
        }
        if (!showAddModal) setIsModalInitialized(false);
    }, [showAddModal, centerModal, setWidthMode, isModalInitialized]);

    // Window resize handling for modal
    useEffect(() => {
        const handleWindowResize = () => {
            if (!modalRef.current || !showAddModal) return;
            const rect = modalRef.current.getBoundingClientRect();
            let newLeft = Math.min(rect.left, window.innerWidth - rect.width);
            let newTop = Math.min(rect.top, window.innerHeight - rect.height);
            newLeft = Math.max(0, newLeft);
            newTop = Math.max(0, newTop);
            if (newLeft !== rect.left || newTop !== rect.top) {
                modalRef.current.style.left = `${newLeft}px`;
                modalRef.current.style.top = `${newTop}px`;
                setModalPosition({ x: newLeft, y: newTop });
            }
        };
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [showAddModal]);

    // Cleanup toast timer on unmount
    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // ─────────────────────────────────────────────────────────
    // 📡 API CALLS
    // ─────────────────────────────────────────────────────────
    const cancelRequests = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
    };

    const loadCustomers = async () => {
        if (!currentShop) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_all_customers',
                    shop_id: currentShop?.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setCustomers(data.data || []);
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error loading customers:', error);
            }
        }
    };

    const loadSuppliers = async () => {
        if (!currentShop) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_all_suppliers',
                    shop_id: currentShop?.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setSuppliers(data.data || []);
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error loading suppliers:', error);
            }
        }
    };

    const loadEmployees = async () => {
        if (!currentShop) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_all_employees',
                    shop_id: currentShop?.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setEmployees(data.data || []);
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error loading employees:', error);
            }
        }
    };

    const loadAllServices = async () => {
        if (!currentShop) return;
        setServicesLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_all_services',
                    shop_id: currentShop?.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setServices(data.data || []);
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error loading services:', error);
                showToast('error', t('Failed to load services'));
            }
        } finally {
            setServicesLoading(false);
        }
    };

    const loadServiceDetails = async (serviceId) => {
        if (!currentShop || !serviceId) return;
        setLoadingServiceId(serviceId);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_service_transactions',
                    shop_id: currentShop?.shop_id,
                    service_id: serviceId
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setServiceDetailsMap(prev => ({ ...prev, [serviceId]: data.data.service }));
                setServiceTransactionsMap(prev => ({ ...prev, [serviceId]: data.data.transactions || [] }));
            } else {
                showToast('error', data.message || t('Failed to load service details'));
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error loading service details:', error);
                showToast('error', t('Failed to load service details'));
            }
        } finally {
            setLoadingServiceId(null);
        }
    };

    const handleServiceClick = async (service) => {
        if (expandedServiceId === service.id) {
            setExpandedServiceId(null);
        } else {
            setExpandedServiceId(service.id);
            if (!serviceDetailsMap[service.id]) {
                await loadServiceDetails(service.id);
            }
        }
    };

    const loadTransactions = async () => {
        if (!currentShop) return;
        cancelRequests();
        abortControllerRef.current = new AbortController();
        isLoadingRef.current = true;
        setLoading(true);

        try {
            const requestBody = {
                action: 'get_transactions',
                shop_id: currentShop.shop_id,
                limit: pagination.limit,
                offset: (pagination.currentPage - 1) * pagination.limit
            };

            if (activeTab !== 'all' && activeTab !== 'service') {
                requestBody.reference_type = activeTab;
            }

            if (filters.start_date) requestBody.start_date = filters.start_date;
            if (filters.end_date) requestBody.end_date = filters.end_date;
            if (filters.transaction_type) requestBody.transaction_type = filters.transaction_type;
            if (filters.status) requestBody.status = filters.status;

            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
                signal: abortControllerRef.current.signal
            });

            const data = await response.json();
            if (data.status === 'success') {
                setTransactions(data.data || []);
                setFilteredTransactions(data.data || []);
                if (data.summary) setSummary(data.summary);
                if (data.pagination) setPagination(prev => ({
                    ...prev,
                    total: data.pagination.total,
                    totalPages: data.pagination.total_pages
                }));
            } else {
                showToast('error', data.message || t('Failed to load transactions'));
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Error loading transactions:', error);
                showToast('error', t('Failed to load transactions'));
            }
        } finally {
            isLoadingRef.current = false;
            setLoading(false);
            abortControllerRef.current = null;
        }
    };

    const loadAllData = async () => {
        if (!currentShop) return;
        await Promise.all([
            loadCustomers(),
            loadSuppliers(),
            loadEmployees(),
            loadAllServices()
        ]);
        await loadTransactions();
    };

    const handleRefresh = async () => {
        setRefreshing(true);
        setPagination(prev => ({ ...prev, currentPage: 1 }));
        await loadAllData();
        setRefreshing(false);
        showToast('success', t('Data refreshed successfully'));
    };

    useEffect(() => {
        if (currentShop) {
            loadAllData();
        }
        return () => {
            cancelRequests();
        };
    }, [currentShop]);

    useEffect(() => {
        if (currentShop && !isLoadingRef.current && activeTab !== 'service') {
            loadTransactions();
        }
    }, [activeTab, pagination.currentPage, filters.start_date, filters.end_date, filters.transaction_type, filters.status]);

    // ─────────────────────────────────────────────────────────
    // 📊 HELPER FUNCTIONS
    // ─────────────────────────────────────────────────────────
    const getTransactionTypeLabel = (type) => {
        const types = {
            service: t('serviceTransactions') || 'Service',
            sale: 'Sale',
            due: t('customerDue') || 'Customer Due',
            payment_received: t('customerPayment') || 'Customer Payment',
            payment_to_supplier: t('supplierPayment') || 'Supplier Payment',
            salary_payment: t('salaryPayment') || 'Salary Payment',
            expense: t('shopExpense') || 'Shop Expense',
            refund: 'Refund'
        };
        return types[type] || type;
    };

    const getTransactionTypeClass = (type) => {
        const classes = {
            'service': 'type-service',
            'sale': 'type-sale',
            'due': 'type-due',
            'payment_received': 'type-payment-received',
            'payment_to_supplier': 'type-payment-to-supplier',
            'salary_payment': 'type-salary',
            'expense': 'type-expense',
            'refund': 'type-refund'
        };
        return classes[type] || 'type-default';
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'completed': return '#10b981';
            case 'pending': return '#f59e0b';
            case 'cancelled': return '#ef4444';
            case 'refunded': return '#8b5cf6';
            default: return '#64748b';
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };

    const formatDate = (date) => {
        if (!date) return 'N/A';
        return new Date(date).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const resetFilters = () => {
        setFilters({
            start_date: '',
            end_date: '',
            transaction_type: '',
            status: '',
            search: ''
        });
        setPagination(prev => ({ ...prev, currentPage: 1 }));
        setFilteredTransactions(transactions);
        loadTransactions();
    };

    const resetForm = () => {
        setFormData({
            reference_id: '',
            amount: '',
            transaction_date: new Date().toISOString().split('T')[0],
            description: '',
            payment_method: 'cash',
            invoice_number: '',
            expense_category: '',
            expense_name: '',
            vendor_name: '',
            salary_type: 'salary'
        });
    };

    const handleViewProfile = async (type, id, name) => {
        if (!id) {
            showToast('error', t('Invalid profile ID'));
            return;
        }

        setProfileType(type);
        setLoading(true);

        try {
            let action = '';
            let requestBody = { shop_id: currentShop?.shop_id };

            switch (type) {
                case 'customer':
                    action = 'get_customer_profile';
                    requestBody.customer_id = id;
                    break;
                case 'supplier':
                    action = 'get_supplier_profile';
                    requestBody.supplier_id = id;
                    break;
                case 'employee':
                    action = 'get_employee_profile';
                    requestBody.employee_id = id;
                    break;
                default:
                    showToast('error', t('Invalid profile type'));
                    setLoading(false);
                    return;
            }

            requestBody.action = action;

            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (data.status === 'success') {
                setSelectedProfile({ ...data.data.profile, summary: data.data.summary, type });
                setProfileTransactions(data.data.transactions || []);
                setShowProfileModal(true);
            } else {
                showToast('error', data.message || t('Failed to load profile'));
            }
        } catch (error) {
            console.error('Error loading profile:', error);
            showToast('error', t('Failed to load profile'));
        } finally {
            setLoading(false);
        }
    };

    const handleAddTransaction = async () => {
        if (!currentShop) {
            showToast('error', t('Select a shop first'));
            return;
        }

        if (!formData.reference_id && transactionType !== 'expense') {
            showToast('error', `Please select a ${transactionType.replace('_', ' ')}`);
            return;
        }

        if (!formData.amount || parseFloat(formData.amount) <= 0) {
            showToast('error', t('Please enter a valid amount'));
            return;
        }

        setLoading(true);

        try {
            let action = '';
            let requestBody = {
                shop_id: currentShop.shop_id,
                username: user?.username,
                ...formData,
                amount: parseFloat(formData.amount)
            };

            switch (transactionType) {
                case 'customer_due':
                    action = 'add_due';
                    requestBody.customer_id = formData.reference_id;
                    break;
                case 'customer_payment':
                    action = 'add_payment';
                    requestBody.customer_id = formData.reference_id;
                    break;
                case 'supplier_payment':
                    action = 'add_supplier_payment';
                    requestBody.supplier_id = formData.reference_id;
                    break;
                case 'employee_salary':
                    action = 'add_employee_salary';
                    requestBody.employee_id = formData.reference_id;
                    break;
                case 'expense':
                    action = 'add_expense';
                    break;
                default:
                    throw new Error('Invalid transaction type');
            }

            requestBody.action = action;

            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_transactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (data.status === 'success') {
                showToast('success', data.message);
                setShowAddModal(false);
                resetForm();
                await loadAllData();
            } else {
                showToast('error', data.message);
            }
        } catch (error) {
            console.error('Error adding transaction:', error);
            showToast('error', t('Failed to add transaction'));
        } finally {
            setLoading(false);
        }
    };

    const exportToPDF = () => {
        const printWindow = window.open('', '_blank');
        const tableRows = filteredTransactions.map((transaction, index) => `
            <tr>
                <td style="padding: 8px; border: 1px solid #ddd; text-align: center;">${index + 1}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${formatDate(transaction.transaction_date)}</td>
                                <td style="padding: 8px; border: 1px solid #ddd;">${formatDate(transaction.transaction_date)}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${getTransactionTypeLabel(transaction.transaction_type)}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${transaction.reference_name || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${transaction.description || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">Rs. ${formatCurrency(transaction.amount)}</td>
                <td style="padding: 8px; border: 1px solid #ddd; text-align: center;">${t(transaction.status) || transaction.status}</td>
            </tr>
        `).join('');

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Transaction History Report</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    h1 { color: #333; text-align: center; }
                    .header { text-align: center; margin-bottom: 30px; }
                    .shop-name { font-size: 18px; color: #666; }
                    table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                    th, td { border: 1px solid #ddd; padding: 10px; text-align: left; }
                    th { background-color: #10b981; color: white; }
                    tr:nth-child(even) { background-color: #f9f9f9; }
                    .footer { margin-top: 30px; text-align: center; font-size: 12px; color: #666; }
                </style>
            </head>
            <body>
                <div class="header">
                    <h1>${t('unifiedTransactions')}</h1>
                    <div class="shop-name">${currentShop?.shop_name || ''}</div>
                    <div>Generated: ${new Date().toLocaleString()}</div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>${t('serialNo')}</th>
                            <th>${t('date')}</th>
                            <th>${t('type')}</th>
                            <th>${t('referenceName')}</th>
                            <th>${t('description')}</th>
                            <th>${t('amount')}</th>
                            <th>${t('status')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${tableRows || '<tr><td colspan="7" style="text-align: center;">No transactions found</td></tr>'}
                    </tbody>
                </table>
                <div class="footer">
                    <p>Generated by OurZest POS System</p>
                </div>
            </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();
    };

    const handleTabChange = (tab) => {
        if (activeTab === tab) return;
        setActiveTab(tab);
        setPagination(prev => ({ ...prev, currentPage: 1 }));
        if (tab !== 'all' && tab !== 'service') {
            setFilters(prev => ({
                ...prev,
                transaction_type: '',
                status: ''
            }));
        }
        if (tab !== 'service') {
            setExpandedServiceId(null);
        }
    };

    // Filter services based on search term
    const filteredServices = serviceSearchTerm.trim() === ''
        ? services
        : services.filter(service =>
            service.service_number?.toLowerCase().includes(serviceSearchTerm.toLowerCase()) ||
            service.customer_name?.toLowerCase().includes(serviceSearchTerm.toLowerCase()) ||
            service.car_number_plate?.toLowerCase().includes(serviceSearchTerm.toLowerCase())
        );

    // ─────────────────────────────────────────────────────────
    // 🎨 RENDER SERVICE TRANSACTIONS TAB
    // ─────────────────────────────────────────────────────────
    const renderServiceTransactionsTab = () => (
        <div className="oztransui-service-container">
            <div className="oztransui-service-selection">
                <div className="oztransui-service-search-wrapper">
                    <div className="oztransui-service-search-input">
                        <FontAwesomeIcon icon={faSearch} className="oztransui-search-icon-inline" />
                        <input
                            type="text"
                            placeholder={t('search')}
                            value={serviceSearchTerm}
                            onChange={(e) => setServiceSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="ozlistui-table-scroll">
                <div className="ozlistui-table-container">
                    <div className="ozlistui-table-wrapper">
                        {servicesLoading ? (
                            <div className="oztransui-loading-container" style={{ padding: '3rem' }}>
                                <div className="oztransui-loading-spinner"></div>
                                <p>{t('loading')}</p>
                            </div>
                        ) : filteredServices.length === 0 ? (
                            <div className="oztransui-no-data">
                                <FontAwesomeIcon icon={faWrench} />
                                <p>{t('noServices') || 'No services found'}</p>
                            </div>
                        ) : (
                            <table className="ozlistui-table">
                                <thead>
                                    <tr>
                                        <th className="ozlistui-id-column ozlistui-centered-cell">{t('serialNo')}</th>
                                        <th className="ozlistui-centered-cell">{t('serviceNumber')}</th>
                                        <th className="ozlistui-centered-cell">{t('customerName')}</th>
                                        <th className="ozlistui-centered-cell">{t('vehicleDetails')}</th>
                                        <th className="ozlistui-centered-cell">{t('date')}</th>
                                        <th className="ozlistui-centered-cell">{t('grandTotal')}</th>
                                        <th className="ozlistui-centered-cell">{t('paidAmount')}</th>
                                        <th className="ozlistui-centered-cell">{t('balanceDue')}</th>
                                        <th className="ozlistui-actions-column ozlistui-centered-cell">{t('actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredServices.map((service, index) => (
                                        <Fragment key={service.id}>
                                            <tr 
                                                className={expandedServiceId === service.id ? 'ozlistui-active' : ''}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleServiceClick(service)}
                                            >
                                                <td className="ozlistui-id-cell ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{index + 1}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text ozlistui-customer-name">{service.service_number}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{service.customer_name || 'Walking Customer'}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text ozlistui-store-name">
                                                        {service.car_model || '-'} ({service.car_number_plate || '-'})
                                                    </span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{formatDate(service.date)}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text ozlistui-amount-cell">Rs. {formatCurrency(service.grand_total)}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text" style={{ color: '#10b981', fontWeight: 600 }}>
                                                        Rs. {formatCurrency(service.paid_amount)}
                                                    </span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text" style={{ color: service.balance > 0 ? '#f59e0b' : '#10b981', fontWeight: 600 }}>
                                                        Rs. {formatCurrency(service.balance)}
                                                    </span>
                                                </td>
                                                <td className="ozlistui-actions-cell ozlistui-centered-cell">
                                                    <div className="ozlistui-actions-content">
                                                        <button
                                                            className="ozlistui-action-btn ozlistui-edit-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleServiceClick(service);
                                                            }}
                                                            title={expandedServiceId === service.id ? t('hideDetails') : t('viewDetails')}
                                                        >
                                                            <FontAwesomeIcon icon={expandedServiceId === service.id ? faChevronUp : faChevronDown} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            
                                            {expandedServiceId === service.id && (
                                                <tr className="oztransui-expanded-row">
                                                    <td colSpan="9" style={{ padding: 0 }}>
                                                        <div className="oztransui-expanded-content">
                                                            {loadingServiceId === service.id ? (
                                                                <div className="oztransui-loading-container" style={{ padding: '2rem' }}>
                                                                    <div className="oztransui-loading-spinner"></div>
                                                                    <p>{t('loading')}</p>
                                                                </div>
                                                            ) : serviceDetailsMap[service.id] ? (
                                                                <>
                                                                    <div className="oztransui-service-details-expanded">
                                                                        <h4><FontAwesomeIcon icon={faWrench} /> {t('serviceInfo')}</h4>
                                                                        <div className="oztransui-service-info-grid-expanded">
                                                                            <div className="oztransui-info-item-expanded">
                                                                                <label>{t('serviceNumber')}:</label>
                                                                                <span>{serviceDetailsMap[service.id].service_number}</span>
                                                                            </div>
                                                                            <div className="oztransui-info-item-expanded">
                                                                                <label>{t('customerName')}:</label>
                                                                                <span>{serviceDetailsMap[service.id].customer_name || 'Walking Customer'}</span>
                                                                            </div>
                                                                            <div className="oztransui-info-item-expanded">
                                                                                <label>{t('date')}:</label>
                                                                                <span>{formatDate(serviceDetailsMap[service.id].date)}</span>
                                                                            </div>
                                                                            <div className="oztransui-info-item-expanded">
                                                                                <label>{t('vehicleDetails')}:</label>
                                                                                <span>{serviceDetailsMap[service.id].car_model || '-'} ({serviceDetailsMap[service.id].car_number_plate || '-'})</span>
                                                                            </div>
                                                                            <div className="oztransui-info-item-expanded">
                                                                                <label>{t('grandTotal')}:</label>
                                                                                <span className="oztransui-amount">Rs. {formatCurrency(serviceDetailsMap[service.id].grand_total)}</span>
                                                                            </div>
                                                                            <div className="oztransui-info-item-expanded">
                                                                                <label>{t('paidAmount')}:</label>
                                                                                <span className="oztransui-amount-paid">Rs. {formatCurrency(serviceDetailsMap[service.id].paid_amount)}</span>
                                                                            </div>
                                                                            <div className="oztransui-info-item-expanded">
                                                                                <label>{t('balanceDue')}:</label>
                                                                                <span className="oztransui-amount-due">Rs. {formatCurrency(serviceDetailsMap[service.id].balance)}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="oztransui-service-transactions-expanded">
                                                                        <h4><FontAwesomeIcon icon={faExchangeAlt} /> {t('relatedTransactions')}</h4>
                                                                        {serviceTransactionsMap[service.id] && serviceTransactionsMap[service.id].length > 0 ? (
                                                                            <div className="ozlistui-table-scroll">
                                                                                <div className="ozlistui-table-container">
                                                                                    <div className="ozlistui-table-wrapper">
                                                                                        <table className="ozlistui-table ozlistui-compact">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th className="ozlistui-id-column ozlistui-centered-cell">{t('serialNo')}</th>
                                                                                                    <th className="ozlistui-centered-cell">{t('date')}</th>
                                                                                                    <th className="ozlistui-centered-cell">{t('type')}</th>
                                                                                                    <th className="ozlistui-centered-cell">{t('description')}</th>
                                                                                                    <th className="ozlistui-centered-cell">{t('amount')}</th>
                                                                                                    <th className="ozlistui-centered-cell">{t('status')}</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {serviceTransactionsMap[service.id].map((transaction, idx) => (
                                                                                                    <tr key={transaction.transaction_id}>
                                                                                                        <td className="ozlistui-id-cell ozlistui-centered-cell">{idx + 1}</td>
                                                                                                        <td className="ozlistui-centered-cell">{formatDate(transaction.transaction_date)}</td>
                                                                                                        <td className="ozlistui-centered-cell">
                                                                                                            <span className={`oztransui-type-badge ${getTransactionTypeClass(transaction.transaction_type)}`}>
                                                                                                                {getTransactionTypeLabel(transaction.transaction_type)}
                                                                                                            </span>
                                                                                                        </td>
                                                                                                        <td className="ozlistui-centered-cell">{transaction.description || '-'}</td>
                                                                                                        <td className="ozlistui-centered-cell ozlistui-amount-cell">Rs. {formatCurrency(transaction.amount)}</td>
                                                                                                        <td className="ozlistui-centered-cell">
                                                                                                            <span className="oztransui-status-badge" style={{ backgroundColor: getStatusColor(transaction.status) }}>
                                                                                                                {t(transaction.status) || transaction.status}
                                                                                                            </span>
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="oztransui-no-data" style={{ padding: '1rem' }}>
                                                                                <p>{t('noTransactions')}</p>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </Fragment>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    if (!currentShop) {
        return (
            <div className={`oztransui-container ${isRTL ? 'oztransui-rtl' : 'oztransui-ltr'} ${darkMode ? 'oztransui-dark' : ''}`}>
                <div className="oztransui-no-shop">
                    <FontAwesomeIcon icon={faStore} />
                    <h3>{t('No Shop Selected')}</h3>
                    <p>{t('Select a shop first')}</p>
                </div>
            </div>
        );
    }

    const totalPages = pagination.totalPages;

    return (
        <div className={`oztransui-container ${isRTL ? 'oztransui-rtl' : 'oztransui-ltr'} ${darkMode ? 'oztransui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            {/* Summary Cards - Icon Left, Value Top, Label Bottom */}
            <div className="oztransui-summary-cards">
                <div className="oztransui-summary-card">
                    <div className="card-icon sales">
                        <FontAwesomeIcon icon={faChartLine} />
                    </div>
                    <div className="card-info">
                        <span className="card-value">Rs. {summary.total_sales?.toLocaleString() || 0}</span>
                        <span className="card-label">{t('totalSales')}</span>
                    </div>
                </div>
                <div className="oztransui-summary-card">
                    <div className="card-icon received">
                        <FontAwesomeIcon icon={faCoins} />
                    </div>
                    <div className="card-info">
                        <span className="card-value">Rs. {summary.total_payments_received?.toLocaleString() || 0}</span>
                        <span className="card-label">{t('totalPaymentsReceived')}</span>
                    </div>
                </div>
                <div className="oztransui-summary-card">
                    <div className="card-icon expenses">
                        <FontAwesomeIcon icon={faChartPie} />
                    </div>
                    <div className="card-info">
                        <span className="card-value">Rs. {summary.total_expenses?.toLocaleString() || 0}</span>
                        <span className="card-label">{t('totalExpenses')}</span>
                    </div>
                </div>
                <div className="oztransui-summary-card">
                    <div className="card-icon net">
                        <FontAwesomeIcon icon={faWallet} />
                    </div>
                    <div className="card-info">
                        <span className="card-value">Rs. {summary.net_balance?.toLocaleString() || 0}</span>
                        <span className="card-label">{t('netBalance')}</span>
                    </div>
                </div>
            </div>
          
            {/* Header Actions Bar */}
            <div className="oztransui-header-actions-bar">
                <div className="oztransui-tabs">
                    <button className={`oztransui-tab ${activeTab === 'all' ? 'active' : ''}`} onClick={() => handleTabChange('all')}>
                        <FontAwesomeIcon icon={faExchangeAlt} /> {t('allTransactions')}
                    </button>
                   
                    <button className={`oztransui-tab ${activeTab === 'customer' ? 'active' : ''}`} onClick={() => handleTabChange('customer')}>
                        <FontAwesomeIcon icon={faUsers} /> {t('customers')}
                    </button>
                    <button className={`oztransui-tab ${activeTab === 'supplier' ? 'active' : ''}`} onClick={() => handleTabChange('supplier')}>
                        <FontAwesomeIcon icon={faTruck} /> {t('suppliers')}
                    </button>
                    <button className={`oztransui-tab ${activeTab === 'employee' ? 'active' : ''}`} onClick={() => handleTabChange('employee')}>
                        <FontAwesomeIcon icon={faUserTie} /> {t('employees')}
                    </button>
                    <button className={`oztransui-tab ${activeTab === 'expense' ? 'active' : ''}`} onClick={() => handleTabChange('expense')}>
                        <FontAwesomeIcon icon={faReceipt} /> {t('expenses')}
                    </button>
                </div>
            </div>

            {/* Filters Section - IMPROVED with scroll wrapper */}
            <div className="oztransui-filters-section">
                <div className="oztransui-filters-scroll-inner">
                    <div className="oztransui-filters-row">
                        <div className="oztransui-filter-group">
                            <div className="oztransui-floating-wrapper">
                                <input
                                    type="date"
                                    id="startDate"
                                    value={filters.start_date}
                                    onChange={(e) => setFilters(prev => ({ ...prev, start_date: e.target.value }))}
                                    placeholder=" "
                                />
                                <label htmlFor="startDate">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                    {t('startDate') || 'Start Date'}
                                </label>
                            </div>
                        </div>
                        <div className="oztransui-filter-group">
                            <div className="oztransui-floating-wrapper">
                                <input
                                    type="date"
                                    id="endDate"
                                    value={filters.end_date}
                                    onChange={(e) => setFilters(prev => ({ ...prev, end_date: e.target.value }))}
                                    placeholder=" "
                                />
                                <label htmlFor="endDate">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                    {t('endDate') || 'End Date'}
                                </label>
                            </div>
                        </div>
                        <CustomDropdown
                            label={t('selectType')}
                            icon={faTag}
                            value={filters.transaction_type}
                            onChange={(val) => setFilters(prev => ({ ...prev, transaction_type: val }))}
                            options={filterTransactionTypeOptions}
                            translations={translations}
                        />
                        <CustomDropdown
                            label={t('status')}
                            icon={faExclamationTriangle}
                            value={filters.status}
                            onChange={(val) => setFilters(prev => ({ ...prev, status: val }))}
                            options={filterStatusOptions}
                            translations={translations}
                        />
                        <div className="oztransui-filter-group">
                            <button onClick={resetFilters} className="oztransui-refresh-btn" title={t('resetFilters')}>
                                <FontAwesomeIcon icon={faRefresh} />
                                <span className="oztransui-btn-text">{t('resetFilters')}</span>
                            </button>
                        </div>
                        <div className="oztransui-actions">
                            <button className="oztransui-btn-pdf" onClick={exportToPDF}>
                                <FontAwesomeIcon icon={faFilePdf} /> <span>{t('exportPDF')}</span>
                            </button>
                            <button className="oztransui-btn-add" onClick={() => setShowAddModal(true)}>
                                <FontAwesomeIcon icon={faPlus} /> <span>{t('addTransaction')}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Loading Overlay */}
            {(loading || refreshing) && activeTab !== 'service' && filteredTransactions.length === 0 && (
                <div className="oztransui-loading-overlay">
                    <div className="oztransui-loading-spinner-large">
                        <FontAwesomeIcon icon={faSpinner} spin size="3x" />
                        <p>{t('loading')}</p>
                    </div>
                </div>
            )}

            {/* Main Content */}
            {activeTab !== 'service' ? (
                <div className="ozlistui-table-scroll">
                    <div className="ozlistui-table-container">
                        <div className="ozlistui-table-wrapper">
                            {filteredTransactions.length === 0 && !loading && !refreshing ? (
                                <div className="oztransui-no-data">
                                    <FontAwesomeIcon icon={faReceipt} />
                                    <p>{t('noTransactions')}</p>
                                </div>
                            ) : (
                                <table className="ozlistui-table">
                                    <thead>
                                        <tr>
                                            <th className="ozlistui-id-column ozlistui-centered-cell">{t('serialNo')}</th>
                                            <th className="ozlistui-centered-cell">{t('date')}</th>
                                            <th className="ozlistui-centered-cell">{t('type')}</th>
                                            <th className="ozlistui-centered-cell">{t('referenceName')}</th>
                                            <th className="ozlistui-centered-cell">{t('description')}</th>
                                            <th className="ozlistui-centered-cell">{t('amount')}</th>
                                            <th className="ozlistui-centered-cell">{t('status')}</th>
                                            <th className="ozlistui-actions-column ozlistui-centered-cell">{t('actions')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredTransactions.map((transaction, index) => (
                                            <tr key={transaction.transaction_id}>
                                                <td className="ozlistui-id-cell ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{index + 1}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text">{formatDate(transaction.transaction_date)}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className={`oztransui-type-badge ${getTransactionTypeClass(transaction.transaction_type)}`}>
                                                        {getTransactionTypeLabel(transaction.transaction_type)}
                                                    </span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <button
                                                        className="oztransui-reference-link"
                                                        onClick={() => handleViewProfile(
                                                            transaction.reference_type,
                                                            transaction.reference_id,
                                                            transaction.reference_name
                                                        )}
                                                    >
                                                        <span className="ozlistui-cell-text ozlistui-customer-name">{transaction.reference_name || '-'}</span>
                                                    </button>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text ozlistui-store-name">{transaction.description || '-'}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="ozlistui-cell-text ozlistui-amount-cell">Rs. {formatCurrency(transaction.amount)}</span>
                                                </td>
                                                <td className="ozlistui-centered-cell">
                                                    <span className="oztransui-status-badge" style={{ backgroundColor: getStatusColor(transaction.status) }}>
                                                        {t(transaction.status) || transaction.status}
                                                    </span>
                                                </td>
                                                <td className="ozlistui-actions-cell ozlistui-centered-cell">
                                                    <div className="ozlistui-actions-content">
                                                        <button
                                                            className="ozlistui-action-btn ozlistui-edit-btn"
                                                            onClick={() => {
                                                                setSelectedTransaction(transaction);
                                                                setShowModal(true);
                                                            }}
                                                            title={t('view')}
                                                        >
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                renderServiceTransactionsTab()
            )}

            {/* Pagination */}
            {activeTab !== 'service' && totalPages > 1 && !loading && !refreshing && filteredTransactions.length > 0 && (
                <div className="ozlistui-pagination">
                    <div className="ozlistui-pagination-info">
                        <span>{t('showing') || 'Showing'} {((pagination.currentPage - 1) * pagination.limit) + 1} {t('of') || 'of'} {filteredTransactions.length} {t('transactions') || 'transactions'}</span>
                    </div>
                    <div className="ozlistui-pagination-controls">
                        <button
                            className="ozlistui-pagination-btn"
                            disabled={pagination.currentPage === 1}
                            onClick={() => setPagination(prev => ({ ...prev, currentPage: prev.currentPage - 1 }))}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                            <span>{t('previous') || 'Previous'}</span>
                        </button>
                        <div className="ozlistui-page-numbers">
                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                let pageNum;
                                if (totalPages <= 5) {
                                    pageNum = i + 1;
                                } else if (pagination.currentPage <= 3) {
                                    pageNum = i + 1;
                                } else if (pagination.currentPage >= totalPages - 2) {
                                    pageNum = totalPages - 4 + i;
                                } else {
                                    pageNum = pagination.currentPage - 2 + i;
                                }
                                return (
                                    <button
                                        key={pageNum}
                                        onClick={() => setPagination(prev => ({ ...prev, currentPage: pageNum }))}
                                        className={`ozlistui-page-number ${pagination.currentPage === pageNum ? 'ozlistui-active' : ''}`}
                                    >
                                        {pageNum}
                                    </button>
                                );
                            })}
                        </div>
                        <button
                            className="ozlistui-pagination-btn"
                            disabled={pagination.currentPage === totalPages}
                            onClick={() => setPagination(prev => ({ ...prev, currentPage: prev.currentPage + 1 }))}
                        >
                            <span>{t('next') || 'Next'}</span>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </div>
                </div>
            )}

            {/* Add Transaction Modal */}
            {showAddModal && (
                <div className="oztransui-modal-overlay" onClick={() => setShowAddModal(false)}>
                    <div 
                        ref={modalRef}
                        className="oztransui-modal-content" 
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'fixed',
                            left: modalPosition.x || '50%',
                            top: modalPosition.y || '50%',
                            transform: modalPosition.x === 0 && modalPosition.y === 0 ? 'translate(-50%, -50%)' : 'none',
                            width: modalSize.width,
                            minWidth: '350px',
                            maxWidth: '95vw',
                            maxHeight: '85vh'
                        }}
                    >
                        {/* Resize Handles */}
                        <div className="oztransui-resize-handle-top" onMouseDown={(e) => startResize(e, 'n')}></div>
                        <div className="oztransui-resize-handle-bottom" onMouseDown={(e) => startResize(e, 's')}></div>
                        <div className="oztransui-resize-handle-left" onMouseDown={(e) => startResize(e, 'w')}></div>
                        <div className="oztransui-resize-handle-right" onMouseDown={(e) => startResize(e, 'e')}></div>
                        <div className="oztransui-resize-handle-nw" onMouseDown={(e) => startResize(e, 'nw')}></div>
                        <div className="oztransui-resize-handle-ne" onMouseDown={(e) => startResize(e, 'ne')}></div>
                        <div className="oztransui-resize-handle-sw" onMouseDown={(e) => startResize(e, 'sw')}></div>
                        <div className="oztransui-resize-handle-se" onMouseDown={(e) => startResize(e, 'se')}></div>

                        <div className="oztransui-modal-header" onMouseDown={startDrag}>
                            <h2>
                                <FontAwesomeIcon icon={faPlus} /> 
                                {t('addTransaction')}
                            </h2>
                            <div className="oztransui-width-control-group">
                                {Object.entries(widthModes).map(([key, mode]) => (
                                    <button 
                                        key={key} 
                                        className={`oztransui-width-btn ${currentWidthMode === key ? 'oztransui-active' : ''}`} 
                                        onClick={() => setWidthMode(key)} 
                                        title={mode.label}
                                    >
                                        <FontAwesomeIcon icon={mode.icon} />
                                    </button>
                                ))}
                            </div>
                            <button className="oztransui-modal-close" onClick={() => setShowAddModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        
                        <div className="oztransui-modal-body">
                            {/* Transaction Type - Custom Dropdown with auto-focus */}
                            <CustomDropdown
                                ref={firstInputRef}
                                label={t('selectType')}
                                icon={faExchangeAlt}
                                value={transactionType}
                                onChange={(val) => { 
                                    setTransactionType(val); 
                                    resetForm();
                                }}
                                options={transactionTypeOptions}
                                translations={translations}
                                disabled={loading}
                            />

                            {/* Reference Selection based on Transaction Type */}
                            {transactionType === 'customer_due' || transactionType === 'customer_payment' ? (
                                <CustomDropdown
                                    label={t('selectCustomer')}
                                    icon={faUsers}
                                    value={formData.reference_id}
                                    onChange={(val) => setFormData(prev => ({ ...prev, reference_id: val }))}
                                    options={customers.map(customer => ({ value: customer.id.toString(), label: customer.name }))}
                                    translations={translations}
                                    disabled={loading}
                                />
                            ) : transactionType === 'supplier_payment' ? (
                                <CustomDropdown
                                    label={t('selectSupplier')}
                                    icon={faTruck}
                                    value={formData.reference_id}
                                    onChange={(val) => setFormData(prev => ({ ...prev, reference_id: val }))}
                                    options={suppliers.map(supplier => ({ value: supplier.id.toString(), label: supplier.name }))}
                                    translations={translations}
                                    disabled={loading}
                                />
                            ) : transactionType === 'employee_salary' ? (
                                <CustomDropdown
                                    label={t('selectEmployee')}
                                    icon={faUserTie}
                                    value={formData.reference_id}
                                    onChange={(val) => setFormData(prev => ({ ...prev, reference_id: val }))}
                                    options={employees.map(employee => ({ value: employee.id.toString(), label: employee.name }))}
                                    translations={translations}
                                    disabled={loading}
                                />
                            ) : transactionType === 'expense' ? (
                                <>
                                    <div className="oztransui-form-group">
                                        <input 
                                            type="text" 
                                            placeholder=" " 
                                            value={formData.expense_category} 
                                            onChange={(e) => setFormData(prev => ({ ...prev, expense_category: e.target.value }))}
                                            disabled={loading}
                                        />
                                        <label>Expense Category</label>
                                    </div>
                                    <div className="oztransui-form-group">
                                        <input 
                                            type="text" 
                                            placeholder=" " 
                                            value={formData.expense_name} 
                                            onChange={(e) => setFormData(prev => ({ ...prev, expense_name: e.target.value }))}
                                            disabled={loading}
                                        />
                                        <label>Expense Name</label>
                                    </div>
                                </>
                            ) : null}

                            {/* Amount Field */}
                            <div className="oztransui-form-group">
                                <input 
                                    type="number" 
                                    step="0.01" 
                                    placeholder=" " 
                                    value={formData.amount} 
                                    onChange={(e) => setFormData(prev => ({ ...prev, amount: e.target.value }))}
                                    disabled={loading}
                                />
                                <label>
                                    <FontAwesomeIcon icon={faDollarSign} />
                                    {t('amount')}
                                </label>
                            </div>

                            {/* Date Field */}
                            <div className="oztransui-form-group">
                                <input 
                                    type="date" 
                                    placeholder=" " 
                                    value={formData.transaction_date} 
                                    onChange={(e) => setFormData(prev => ({ ...prev, transaction_date: e.target.value }))}
                                    disabled={loading}
                                />
                                <label>
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                    {t('date')}
                                </label>
                            </div>

                            {/* Payment Method - Custom Dropdown */}
                            <CustomDropdown
                                label={t('paymentMethod')}
                                icon={faCreditCard}
                                value={formData.payment_method}
                                onChange={(val) => setFormData(prev => ({ ...prev, payment_method: val }))}
                                options={paymentMethodOptions}
                                translations={translations}
                                disabled={loading}
                            />

                            {/* Invoice Number Field */}
                            <div className="oztransui-form-group">
                                <input 
                                    type="text" 
                                    placeholder=" " 
                                    value={formData.invoice_number} 
                                    onChange={(e) => setFormData(prev => ({ ...prev, invoice_number: e.target.value }))}
                                    disabled={loading}
                                />
                                <label>
                                    <FontAwesomeIcon icon={faFileInvoice} />
                                    {t('invoiceNumber')}
                                </label>
                            </div>

                            {/* Description Field */}
                            <div className="oztransui-form-group">
                                <textarea 
                                    rows="3" 
                                    placeholder=" " 
                                    value={formData.description} 
                                    onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                                    disabled={loading}
                                />
                                <label>
                                    <FontAwesomeIcon icon={faStickyNote} />
                                    {t('description')}
                                </label>
                            </div>
                        </div>
                        
                        <div className="oztransui-modal-footer">
                            <button className="oztransui-btn-cancel" onClick={() => setShowAddModal(false)} disabled={loading}>
                                {t('cancel')}
                            </button>
                            <button className="oztransui-btn-primary" onClick={handleAddTransaction} disabled={loading}>
                                {loading ? <div className="oztransui-spinner-small"></div> : <><FontAwesomeIcon icon={faSave} /> {t('save')}</>}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Transaction Details Modal */}
            {showModal && selectedTransaction && (
                <div className="oztransui-modal-overlay" onClick={() => { setShowModal(false); setSelectedTransaction(null); }}>
                    <div className="oztransui-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="oztransui-modal-header">
                            <h2><FontAwesomeIcon icon={faReceipt} /> {t('transactionDetails')}</h2>
                            <button className="oztransui-modal-close" onClick={() => { setShowModal(false); setSelectedTransaction(null); }}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="oztransui-modal-body">
                            <div className="oztransui-details-grid">
                                <div className="oztransui-detail-item"><label>{t('date')}</label><span>{formatDate(selectedTransaction.transaction_date)}</span></div>
                                <div className="oztransui-detail-item"><label>{t('type')}</label><span>{getTransactionTypeLabel(selectedTransaction.transaction_type)}</span></div>
                                <div className="oztransui-detail-item"><label>{t('referenceName')}</label><span>{selectedTransaction.reference_name || '-'}</span></div>
                                <div className="oztransui-detail-item"><label>{t('amount')}</label><span className="oztransui-amount">Rs. {formatCurrency(selectedTransaction.amount)}</span></div>
                                <div className="oztransui-detail-item"><label>{t('paymentMethod')}</label><span>{selectedTransaction.payment_method || '-'}</span></div>
                                <div className="oztransui-detail-item"><label>{t('status')}</label><span className="oztransui-status-badge" style={{ backgroundColor: getStatusColor(selectedTransaction.status) }}>{t(selectedTransaction.status)}</span></div>
                                <div className="oztransui-detail-item oztransui-full-width"><label>{t('description')}</label><span>{selectedTransaction.description || '-'}</span></div>
                            </div>
                        </div>
                        <div className="oztransui-modal-footer">
                            <button className="oztransui-btn-secondary" onClick={() => { setShowModal(false); setSelectedTransaction(null); }}>{t('close')}</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Profile Modal */}
            {showProfileModal && selectedProfile && (
                <div className="oztransui-modal-overlay" onClick={() => setShowProfileModal(false)}>
                    <div className="oztransui-modal-content oztransui-profile-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="oztransui-modal-header">
                            <h2><FontAwesomeIcon icon={faUserTie} /> {selectedProfile.customer_name || selectedProfile.supplier_name || selectedProfile.employee_name}</h2>
                            <button className="oztransui-modal-close" onClick={() => setShowProfileModal(false)}><FontAwesomeIcon icon={faTimes} /></button>
                        </div>
                        <div className="oztransui-modal-body">
                            <div className="oztransui-profile-summary">
                                <h3>{t('profileSummary')}</h3>
                                <div className="oztransui-summary-stats">
                                    <div className="oztransui-stat"><label>{t('totalPurchases')}:</label><span>Rs. {formatCurrency(selectedProfile.total_purchases || 0)}</span></div>
                                    <div className="oztransui-stat"><label>{t('totalPaid')}:</label><span>Rs. {formatCurrency(selectedProfile.total_paid || 0)}</span></div>
                                    <div className="oztransui-stat"><label>{t('currentDue')}:</label><span className="oztransui-due-amount">Rs. {formatCurrency(selectedProfile.total_due || 0)}</span></div>
                                </div>
                            </div>
                            <div className="oztransui-profile-transactions">
                                <h3>{t('transactionHistory')}</h3>
                                <div className="oztransui-transactions-list">
                                    {profileTransactions.length === 0 ? (
                                        <p className="oztransui-no-data">{t('noTransactions')}</p>
                                    ) : (
                                        <table className="oztransui-transactions-table oztransui-compact">
                                            <thead>
                                                <tr>
                                                    <th>{t('serialNo')}</th>
                                                    <th>{t('date')}</th>
                                                    <th>{t('type')}</th>
                                                    <th>{t('amount')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {profileTransactions.map((transaction, idx) => (
                                                    <tr key={transaction.transaction_id}>
                                                        <td className="ozlistui-id-cell ozlistui-centered-cell">{idx + 1}</td>
                                                        <td>{formatDate(transaction.transaction_date)}</td>
                                                        <td>{getTransactionTypeLabel(transaction.transaction_type)}</td>
                                                        <td className="oztransui-amount-cell">Rs. {formatCurrency(transaction.amount)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="oztransui-modal-footer">
                            <button className="oztransui-btn-secondary" onClick={() => setShowProfileModal(false)}>{t('close')}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TransactionsManager;